import {
  BaseReq,
  PaginationReq,
  PaginationResp,
  UpdaterResp,
  BaseClass,
  FileRecord,
} from "@/core/interface";
import { getCurrentCompanyId, getCurrentUserId } from "@/utils";
import moment from "moment";
/**
 * Tab 枚举
 */
export enum ContractTabEnum {
  BASIC_TAB = "BASIC_TAB", // 基本信息
  DETAILS_TAB = "DETAILS_TAB", // 设备租赁明细
  ATTACHMENT_TAB = "ATTACHMENT_TAB", // 附件
  FLOW_TAB = "FLOW_TAB", //流程
}

export class LeaseContractPageReq extends PaginationReq {
  contractOfTenancyName: string | undefined = undefined; // 合同名称
  cooperationCompanyId: number | undefined = undefined; //供应商ID
  startDate: string | undefined = undefined; //签订开始日期
  endDate: string | undefined = undefined; //签订结束日期
  handlerPartyId: string | undefined = undefined; // 经办人ID
  contractStatus: string | undefined = undefined; // 合同状态
  outBizNo: string | undefined = undefined; // 外部合同编号
}

export class LeaseContractRecord extends UpdaterResp {
  id: string = ""; // 合同ID
  bizNo: string = ""; // 租赁合同编号
  contractOfTenancyName: string = ""; // 合同名称
  cooperationCompanyName: string = ""; // 供应商
  projectName: string = ""; // 项目名称
  contractSigningDate: string = ""; // 签订日期
  estimateContractAmount: number = 0; // 预计合同金额
  agentOfParty: string = ""; // 经办人名称（己方）
  contractStatus: string = ""; //合同状态
}

export class LeaseContractResp extends PaginationResp<LeaseContractRecord> {}

export class LeaseContractSimpleRecord {
  bizNo: string = ""; // 合同编号
  id: string = ""; // 合同ID
  contractOfTenancyName: string = ""; // 合同名称
}
export class LeaseContractSimpleReq extends BaseClass {
  size: number = 0;
  current: number = 1;
  addRightBizType: string | undefined = undefined;
  firstDisplayProjectId: string | undefined = undefined;
}
export class LeaseContractSimpleListResp extends PaginationResp<LeaseContractSimpleRecord> {}

export class LeaseContractReq extends BaseReq {
  contractOfTenancyName: string = ""; //合同名称
  projectId: string | undefined = undefined; // 所属项目ID
  outBizNo: string = ""; // 外部合同编号
  cooperationCompanyId: string = ""; // 乙方ID
  contractSigningDate: string = ""; // 签订日期
  signingStartDate: string = ""; // 开始日期
  signingEndDate: string = ""; // 结束日期
  estimateContractAmount: number | undefined = undefined; //预估合同金额
  agentOfParty: string = ""; //乙方经办人
  bargainMoney: number | undefined = undefined; //预付款
  earnestMoney: number | undefined = undefined; // 保证金
  handlerPartyId: string = getCurrentUserId(); // 己方ID
  provinceId: number | undefined = undefined; //省
  cityId: number | undefined = undefined; //市
  districtId: number | undefined = undefined; //区
  thePerformanceAddress: string = ""; // 履约地
  paymentAgreemen: string = ""; // 收款协议
  mainClause: string = ""; // 主要条款
  remark: string = ""; // 备注
  equipmentDetailAddAReqs: LeaseDetail[] = [];
  fileList: FileRecord[];
}

export class LeaseDetail extends BaseReq {
  leaseItemName: string = ""; //租赁物品名称
  specificationsModels: string = ""; //规格型号
  unitName: string = ""; //物品单位
  leaseAmount: number | undefined = undefined; //租赁数量
  chargeUnit: string | undefined = undefined; //计费单位
  rentPrice: number | undefined = undefined; //租赁单价
  planIntoDate: string = moment().format("YYYY-MM-DD"); //计划进场日期
  planOutDate: string = ""; //计划退场日期
  expectedTime: number | undefined = undefined; //预计时长
  expectedLeaseExpenditure: number | undefined = undefined; //预计租赁费
  remark: string = ""; //备注
  contractOfTenancyId: string = ""; //租赁合同id
}

export class LeaseContractInfo extends LeaseContractReq {
  id: number | undefined = undefined; //id
  bizNo: string = ""; // 租赁合同编号
  projectName: string = ""; //项目名称
  cooperationCompanyName: string = ""; // 供应商
  handlerPartyName: string = ""; //经办人甲方
  flowStatus: string = ""; //审批状态
  contractStatusName: string = ""; //合同状态
  unitName:string = ""; //合同状态
}

export class LeaseDetailImportResp {
  records: LeaseDetail[] = [];
}

export class LeaseContractCount {
  alreadyPayMoney: number | undefined = undefined; //已付款金额(￥)
  alreadyRecieveMoney: number | undefined = undefined; //已收票金额(￥)	number
  alreadyRequestNotPayMoney: number | undefined = undefined; //已申请未付款金额(￥)	number
  cooperationCompanyId: string = ""; //供应商(往来单位)id	integer(int64)
  cooperationCompanyName: string = ""; //供应商(往来单位)	string
  currentMoney: number | undefined = undefined; //当前合同金额(￥)	number
  projectId: string = ""; //所属项目id	integer(int64)
  projectName: string = ""; //所属项目名称	string
  totalMoney: number | undefined = undefined; //累计结算金额(￥)
  estimateContractAmount: number | undefined = undefined; //预估合同金额
}
